export const SET_COOKIE_OPTIONS = { domain: window.location.hostname, path: '/' };
